import {
  MobileUrlConfigReturnTypes,
  UrlConfigReturnTypes,
} from '@/shared/Hooks/useNavigation';

export const getRedirectionUrlTo = ({
  url,
}: {
  url: UrlConfigReturnTypes | MobileUrlConfigReturnTypes;
}) => {
  const origin =
    typeof window === 'undefined'
      ? process.env.NEXT_PUBLIC_FRONT_URL
      : window.location.origin;

  return origin + url;
};
